// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"098d7260","573":"4e97b00d","701":"defa136b","736":"2007a712","861":"e34ce11e"}[chunkId] + ".chunk.css";
};